/**
 * Vendor Application container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { publicFilesUrlsSelector } from '../VendorApplication/selectors';
import { currentUserSelector, loggedInSelector } from '../App/selectors';
import { userSelector } from '../User/selectors';
import InfluencerUserInfo from '../../Components/InfluencerUserInfo/InfluencerUserInfo';
import promisifyActions from '../../Lib/Utils/promisify-actions';
import { actions as userActions } from '../User/slice';

function InfluencerUserInfoContainer(props) {
  return <InfluencerUserInfo {...props} />;
}

/**
 * Properties to be provided to the Vendor Application component
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  isLoggedIn: loggedInSelector(state),
  currentUser: currentUserSelector(state),
  publicFilesUrls: publicFilesUrlsSelector(state),
  user: userSelector(state),
});

/**
 * Actions to be dispatched
 * @param {function} dispatch function to dispatch vendor application actions
 */
const mapDispatchToProps = (dispatch) => ({
  updateUserSuccess: (user) =>
    dispatch(userActions.updateUserSuccess({ user })),
});

/**
 * Connects state to the Vendor Application component
 * @param {object} mapStateToProps data object to become props for the Vendor Application component
 * @param {object} mapDispatchToProps Vendor Application actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )(InfluencerUserInfoContainer),
);
